module.exports = __webpack_public_path__ + "media/newstyle/images/icon-add-18add01dfa3e1a4485102fb62a86a318.svg";